export const ADD_SEQUENCE_STEPS = {
  CONTACTS_START_STEP: 1,
  CONTACTS_PREVIEW_STEP: 2,
  PITCHES_STEP: 3,
  SCHEDULE_STEP: 4,
  SUMMARY_STEP: 5,
};

export const ADD_SEQUENCE_STEPPER_STEPS = [
  { label: 'ADD CONTACTS', value: 1 },
  { label: 'CREATE PITCHES', value: 3 },
  { label: 'SCHEDULE', value: 4 },
  { label: 'SUMMARY', value: 5 },
];

export const DEFAULT_CONTACT_QUERY_PARAMS = {
  active: true,
  detail_page: true,
  exlude_self: false,
};

export const DEFAULT_SEQUENCE_NAME = 'Sequence Name';
